import React from "react";
import ReactDOM from "react-dom";
import * as DIAG from "storm-react-diagrams";
import { defaultServiceContext } from "../contexts";
import Submenu from "../form_components/Submenu";
import BaseLinkModel from "../models/BaseLinkModel";
import BaseNodeModel from "../models/BaseNodeModel";
import { FeatureFlag } from "../services";
import NewElementDialog from "./dialogs/NewElementDialog";
import NewFolderDialog from "./dialogs/NewFolderDialog";
import Utility from "../utilities/Utility";
import FileSaver from "file-saver";
import { Constant } from '../const';
import VariableRefactorDialog from "./dialogs/VariableRefactorDialog";
import VariableDataModel from "../models/VariableDataModel";
import UsedInDialog from "./dialogs/UsedInDialog";
import CanvasTabManager from "../utilities/CanvasTabManager";
import ExitNodes from "./components/ExitNodes";


// Array of colors; define color code in theme.scss using the exact name as variable name
const demoColors = ["lime", "yellow", "blue", "purple",
    "pink", "brown", "cyan", "green",
    "orange", "red", "primary"];

// Array of icons; only those exists in the Feature Icon font can show up correctly; leave out "icon-" prefix
const demoIcons = ["activity", "airplay", "alert-circle", "alert-octagon", "alert-triangle", "align-center", "check-square",
    "align-justify", "align-left", "align-right", "anchor", "aperture", "arrow-down-left", "arrow-down-right",
    "arrow-down", "arrow-left", "arrow-right", "arrow-up-left", "arrow-up-right", "arrow-up", "at-sign", "award",
    "bar-chart-2", "bar-chart", "battery-charging", "battery", "bell-off", "bell", "bluetooth", "book",
    "bookmark", "box", "briefcase", "calendar", "camera-off", "camera", "cast", "check-circle", "check-square",
    "check", "chevron-down", "chevron-left", "chevron-right", "chevron-up", "chevrons-down", "chevrons-left",
    "chevrons-right", "chevrons-up", "chrome", "circle", "clipboard", "clock", "cloud-drizzle", "cloud-lightning",
    "cloud-off", "cloud-rain", "cloud-snow", "cloud", "codepen", "command", "compass", "copy", "corner-down-left",
    "corner-down-right", "corner-left-down", "corner-left-up", "corner-right-down", "corner-right-up", "corner-up-left",
    "corner-up-right", "cpu", "credit-card", "crosshair", "delete", "disc", "download-cloud", "download",
    "droplet", "edit-2", "edit-3", "edit", "external-link", "eye-off", "eye", "facebook", "fast-forward", "feather",
    "file-minus", "file-plus", "file-text", "file", "film", "filter", "flag", "folder", "github", "gitlab", "globe",
    "grid", "hash", "headphones", "heart", "home", "image", "inbox", "info", "instagram",
    "layers", "layout", "life-buoy", "link-2", "link", "list", "loader", "lock", "log-in", "log-out", "mail",
    "map-pin", "map", "maximize-2", "maximize", "menu", "message-circle", "message-square", "mic-off", "mic",
    "minimize-2", "minimize", "minus-circle", "minus-square", "minus", "monitor", "moon", "more-horizontal",
    "more-vertical", "move", "music", "navigation-2", "navigation", "octagon", "package", "paperclip", "pause-circle",
    "pause", "percent", "phone-call", "phone-forwarded", "phone-incoming", "phone-missed", "phone-off",
    "phone-outgoing", "phone", "pie-chart", "play-circle", "play", "plus-circle", "plus-square", "plus", "pocket",
    "power", "printer", "radio", "refresh-ccw", "refresh-cw", "repeat", "rewind", "rotate-ccw", "rotate-cw", "save",
    "scissors", "search", "server", "settings", "share-2", "share", "shield", "shuffle", "sidebar",
    "skip-back", "skip-forward", "slack", "slash", "sliders", "smartphone", "speaker", "square", "star", "stop-circle",
    "sun", "sunrise", "sunset", "tablet", "tag", "target", "thermometer", "thumbs-down", "thumbs-up", "toggle-left",
    "toggle-right", "trash-2", "trash", "trending-down", "trending-up", "triangle", "tv", "twitter", "type", "umbrella",
    "unlock", "upload-cloud", "upload", "user-check", "user-minus", "user-plus", "user-x", "user", "users",
    "video-off", "video", "voicemail", "volume-1", "volume-2", "volume-x", "volume", "watch", "wifi-off", "wifi", "wind",
    "x-circle", "x-square", "x", "zap", "zoom-in", "zoom-out", "chevron-down"];

const { avsService } = defaultServiceContext;

export default class ContextMenuWidget extends React.Component {
    /**
     * Context menu
     * @module ContextMenuWidget
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.clickOutsideHandler = this.handleClickOutside.bind(this);
        this.closeNewElementPopup = this.closeNewElementPopup.bind(this);
        this.openNewElementDialog = this.openNewElementDialog.bind(this);
    }

    /**
     * Get reference to context menu container itself
     * @returns {jQuery}
     */
    getDomSelf() {
        return $(ReactDOM.findDOMNode(this));
    }

    /**
     * Get top value for menu element, provide offset to prevent x-axis overflows
     * @return {number}
     */
    getOffsetTop() {
        const domHeight = this.props.domContext.outerHeight();
        const domTop = this.props.pos.top;
        const canvasHeight = apm.getCurrentDiagramWidget().graphModel.graphEngine.canvas.clientHeight; //viewable area
        const versionFooterHeight = 20; //approximate height of app footer element // TODO: dynamic reference
        const isDescending = (domTop + domHeight) > canvasHeight;

        //if context menu descends below visible canvas
        if (isDescending) {
            // offset top 
            return ((domTop) - (domTop + domHeight - (canvasHeight - versionFooterHeight)));
        }

        return domTop;
    }

    /**
     * Position the context menu
     */
    positionDomContext() {
        // prevent x-axis overflow
        const offsetTop = this.getOffsetTop();

        this.props.domContext.css({
            "left": this.props.pos.left,
            "top": this.props.absolute ? this.props.pos.top : offsetTop,
        }).stop().fadeIn(200);
        this.getDomSelf().find('[tabindex=0]:first').focus();
    }

    /**
     * Hide the context menu
     */
    hideMenu() {
        this.props.domContext.hide();
    }


    // called on updates (re-renders)
    componentDidUpdate() {
        this.positionDomContext();
    }

    // called on initial rendering
    componentDidMount() {
        document.addEventListener('mousedown', this.clickOutsideHandler);
        document.addEventListener('ev-close-new-element-dialog', this.closeNewElementPopup);
        document.addEventListener("ev-open-new-element-dialog", this.openNewElementDialog);
        this.positionDomContext();
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.clickOutsideHandler);
        document.removeEventListener('ev-close-new-element-dialog', this.closeNewElementPopup);
        document.removeEventListener("ev-open-new-element-dialog", this.openNewElementDialog);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    /**
     * Hide menu if mouse click outside boundary
     * @param {Object} event React event
     */
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.hideMenu();
        }
    }

    /**
     * Render context menu for click on empty space on canvas
     * @returns {XML}
     */
    renderCanvasMenu() {
        const prefix = "canvas";

        const clipboard = window.apm.cache.get(Constant.k.NAMESPACE_DATATRANSFER, "clipboard");
        //check if common module exists from the selected nodes on canvas. If it is false show clone option.
        const isCommonModuleSelected = ()=>{
            if(clipboard&&clipboard.nodes.length>0){
                clipboard.nodes.forEach(node=>{
                    if(node.props.isCommonModule) return true;
                })
            }
        }
        //return (clipboard && clipboard.nodes && clipboard.nodes.length > 0);

        return (
            <ul>
                {!window.apm.getCurrentDiagramWidget().props.node.props.isCommonModule &&
                    <TextContextItem label={window.l.context_menu.create_item}
                        context={this}
                        key={prefix + "createItem"}
                        onClick={(event) => this.treeTitleMenuCallback("object", {
                            clientX: event.clientX,
                            clientY: event.clientY
                        })}
                    />}
                {!window.apm.getCurrentDiagramWidget().props.node.props.isCommonModule &&clipboard && clipboard.nodes && clipboard.nodes.length > 0 && <TextContextItem label={window.l.context_menu.paste_here}
                    context={this}
                    key={prefix + "paste"}
                    onClick={(event) => {
                        window.apm.postEventToCurrentView({
                            target: "request-paste",
                            event: { x: this.props.pos.left, y: this.props.pos.top }
                        });
                    }}
                />}
                {!isCommonModuleSelected() && !window.apm.getCurrentDiagramWidget().props.node.props.isCommonModule && clipboard && clipboard.nodes && clipboard.nodes.length > 0 && <TextContextItem label={window.l.context_menu.paste_clone}
                    context={this}
                    key={prefix + "paste-clone"}
                    onClick={(event) => {
                        window.apm.postEventToCurrentView({
                            target: "request-duplicate",
                            event: { x: this.props.pos.left, y: this.props.pos.top }
                        });
                    }}
                />}
                {!window.apm.getCurrentDiagramWidget().props.node.props.isCommonModule &&<TextContextItem label={window.l.context_menu.select_all}
                    context={this}
                    key={prefix + "all"}
                    onClick={() => {
                        window.apm.postEventToCurrentView({ target: "request-select-all" })
                    }}
                />}
                {!window.apm.getCurrentDiagramWidget().props.node.elemId &&
                    <TextContextItem label={window.l.context_menu.properties}
                        context={this}
                        key={prefix + "prop"}
                        onClick={() => {
                            window.apm.postEventToCurrentView({ target: "request-clear-selection" });
                            window.apm.postEventToCurrentView({ target: "request-component-panel" });
                        }}
                    />}
            </ul>
        );
    }

    /**
     * Render context menu for click on a multiple selection
     * @returns {XML}
     */
    renderSelectionMenu() {
        const prefix = "selection";
        return (
            <ul>
                {<TextContextItem label={window.l.context_menu.copy} context={this} key={prefix + "copy"}
                    onClick={() => {
                        window.apm.postEventToCurrentView({ target: "request-copy" })
                    }} />}
                {<TextContextItem label={window.l.context_menu.remove} context={this} key={prefix + "remove"}
                    onClick={() => {
                        window.apm.postEventToCurrentView({ target: "request-delete", type: "delete-multiple" })
                    }} />}
                {<TextContextItem label={window.l.context_menu.select_all} context={this} key={prefix + "all"}
                    onClick={() => {
                        window.apm.postEventToCurrentView({ target: "request-select-all" })
                    }} />}
                
            </ul>
        );
    }

    /**
     * Render context menu for clicking on a single node
     * @returns {XML}
     */
    renderNodeMenu() {
        const prefix = "node";
        const isCommonModuleCanvas = window.apm.getCurrentDiagramWidget().props.node.props.isCommonModule;
        const isMetLife = window.apm.serialized.client === "MetLife";

        const wizardConfig= Utility.getCookieBool(FeatureFlag.wizardConfig);
        return (
            <ul >

                {!isCommonModuleCanvas&&this.props.context.model.props.nodeTypeName && this.props.context.model.props.nodeTypeName !== "Module Begin" &&
                    <TextContextItem label={"Replace With..."} context={this} key={prefix + "replace"}
                        onClick={(event) => {this.treeTitleMenuCallback("object", {
                            clientX: event.clientX,
                            clientY: event.clientY,
                            replace: true
                        })}} />}
                {!isCommonModuleCanvas && this.props.context.model.props.nodeTypeName && this.props.context.model.props.nodeTypeName !== "Module Begin" &&
                    <TextContextItem label={window.l.context_menu.copy} context={this} key={prefix + "copy"}
                        onClick={() => {
                            window.apm.postEventToCurrentView({ target: "request-copy" })
                        }} />}
                {!this.props.context.model.props.isCommonModule && this.props.context.model.props.nodeTypeName && this.props.context.model.props.nodeTypeName !== "Module Begin" &&
                    <TextContextItem label={window.l.context_menu.clone_and_replace} context={this}
                        key={prefix + "clone"}
                        onClick={() => {
                            window.apm.postEventToCurrentView({ target: "request-copy" });
                            window.apm.postEventToCurrentView({ target: "request-clone" })
                        }} />}
                {!this.props.context.model.props.isCommonModule && this.props.context.model.props.nodeTypeName && this.props.context.model.props.nodeTypeName !== "Module Begin" &&
                    <TextContextItem label={window.l.context_menu.clone} context={this} key={prefix + "duplicate"}
                        onClick={() => {
                            window.apm.postEventToCurrentView({ target: "request-copy" });
                            window.apm.postEventToCurrentView({ target: "request-duplicate" })
                        }} />}


                {!isCommonModuleCanvas && this.props.context.model.props.nodeTypeName !== "Module Begin" &&
                    <TextContextItem label={window.l.context_menu.cut} context={this} key={prefix + "cut"}
                        onClick={() => {
                            window.apm.postEventToCurrentView({ target: "request-copy" });
                            window.apm.postEventToCurrentView({ target: "request-delete" , type: "cut-node"})
                        }} />}
                {this.props.context.model.props.isCommonModule && this.props.context.model.props.isRootModule&&this.props.context.model.type === "module" && wizardConfig&&
                    <TextContextItem label={"Open Wizard Config"} context={this} key={prefix + "Open Wizard Config"} 
                    enableCheck={this.props.context.model.props.hasWizardConfig}
                        onClick={() => {
                            const parentNode = window.apm.serialized.components.modules.find(m => m.id === this.props.context.model.props.parentComponentID)
                            this.openCommonModuleWizard(parentNode);
                        }} />}

                {this.props.context.model.props.nodeTypeName !== "Module Begin" && this.props.context.model.props.nodeTypeName !== 'Note' &&
                    <TextContextItem label={window.l.popup.used_in} context={this} key={prefix + "used"}
                        onClick={() => {
                            window.apm.popup(this.props.context.model.name,
                                '<div class="new_element_container"></div>',
                                '<button class="w2ui-btn primary">' + window.l.popup.close + '</button> ',
                                [
                                    ".new_element_container",

                                    () => {
                                        ReactDOM.render(
                                            <UsedInDialog
                                                isComponentNode={false}
                                                serialized={window.apm.serialized}
                                                node={this.props.context.model} />, $(".new_element_container").get(0));

                                        $(".w2ui-popup").find(".w2ui-btn.primary").on("click", function () {
                                            ReactDOM.unmountComponentAtNode($(".new_element_container").get(0));
                                            w2popup.close();
                                        });

                                    }
                                ]

                            );
                        }} />}
                {this.props.context.model.type === "module" &&
                    <TextContextItem label={window.l.popup.exit_values} context={this} key={this.props.context.model.type  + "exitValues"}
                        onClick={() => {
                            const { model } = this.props.context;
                            const icon = `fe icon-${model.props.iconClass}`;
                            const parentNodeId = model.props.parentComponentID;

                            window.apm.popup(`<i class="${icon}" style="padding-right: 4px"></i>${model.name} ${window.l.popup.exit_values}:`,
                                '<div class="new_element_container"></div>',
                                `<button class="w2ui-btn primary">${window.l.popup.close}</button>`,
                                [
                                    ".new_element_container",

                                    // Please replace this anonymous function with a React componet
                                    () => {

                                        const { versions } = window.apm.serialized.components.modules.find(mod => mod.id === parentNodeId);
                                        const { flow: { nodes, links } } = versions[1];

                                        ReactDOM.render(
                                            <ExitNodes
                                                links={links}
                                                nodes={nodes}
                                            />, $(".new_element_container").get(0));

                                        $(".w2ui-popup").find(".w2ui-btn.primary").on("click", function () {
                                            ReactDOM.unmountComponentAtNode($(".new_element_container").get(0));
                                            w2popup.close();
                                        });

                                    }
                                ]

                            );
                            
                        }} />}
                {!this.props.context.model.isCommonModule && this.props.context.model.props.nodeTypeName && this.props.context.model.props.nodeTypeName !== "Module Begin" &&
                    <TextContextItem label={window.l.context_menu.remove} context={this} key={prefix + "remove"}
                        onClick={() => {
                            window.apm.postEventToCurrentView({ target: "request-delete", type: "delete-node" })
                        }} />}

                {isMetLife && !window.apm.getCurrentDiagramWidget().props.node.props.isCommonModule && !this.props.context.model.isSpecialNode() && ([
                    <CarouselContextItem set={"color"} context={this} key={prefix + "color"} />
                ])}
            </ul>
        );
    }

    /**
     * Render context menu for clicking on a link
     * @returns {XML}
     */
    renderLinkMenu() {
        const prefix = "link";
        const isMetLife = window.apm.serialized.client === "MetLife";

        return (
            <ul>
                {!window.apm.getCurrentDiagramWidget().props.node.props.isCommonModule &&
                    <TextContextItem label={"Insert Object"} context={this} key={prefix + "insert"}
                        onClick={(event) => {this.treeTitleMenuCallback("object", {
                            clientX: event.clientX,
                            clientY: event.clientY,
                            insert: true
                        })}} />}
                {!window.apm.getCurrentDiagramWidget().props.node.props.isCommonModule &&
                    <TextContextItem label={window.l.context_menu.remove} context={this} key={prefix + "remove"}
                        onClick={() => {
                            window.apm.postEventToCurrentView({ target: "request-delete", type: "delete-link" })
                        }} />}
                {!window.apm.getCurrentDiagramWidget().props.node.props.isCommonModule &&
                    <TextContextItem label={window.l.context_menu.select_all} context={this} key={prefix + "all"}
                        onClick={() => {
                            window.apm.postEventToCurrentView({ target: "request-select-all" })
                        }} />}

                {isMetLife &&
                    <CarouselContextItem set={"color"} context={this} key={prefix + "color"} />
                }

            </ul>
        );
    }

    closeNewElementPopup() {
        w2popup.close();
        ReactDOM.unmountComponentAtNode($(".new_element_container").get(0));
    }
    openNewElementDialog() {
        this.treeTitleMenuCallback('module');
    }
    /**
     * Callback for application tree
     * @param {string} type Element type
     * @param {Object|null} event React mouse event
     */
    treeTitleMenuCallback(type, event = null) {
        window.apm.popup(window.l.popup.new_element,
            '<div class="new_element_container"></div>',
            '<button class="w2ui-btn secondary" onClick="w2popup.close()">' + window.l.popup.close + '</button> ' +
            '<button class="w2ui-btn primary add-button">' + window.l.popup.add + '</button> ',
            [
                ".new_element_container",

                () => {
                    ReactDOM.render(<NewElementDialog
                        type={type}
                        event={event} />,
                        $(".new_element_container").get(0));

                    $(".w2ui-popup").find(".add-button").on("click", function () {
                        document.dispatchEvent(new CustomEvent("ev-dialog-add"));
                    });

                
                }
            ]
            
        );
    }

    /**
     * Callback for application tree folder
     * @param {string} type Element type
     * @param {Object|null} event React mouse event
     */
    treeTitleFolderMenuCallback(type, event = null) {
        window.apm.popup("Module Folder Configuration",
            '<div class="new_element_container"></div>',
            '<button class="w2ui-btn secondary">' + window.l.popup.close + '</button> ',
            [
                ".new_element_container",
            
                () => {
                    ReactDOM.render(<NewFolderDialog type={type} event={event} />, $(".new_element_container").get(0));
                    
                    $(".w2ui-popup").find(".secondary").on("click", function () {
                        ReactDOM.unmountComponentAtNode($(".new_element_container").get(0));
                        w2popup.close()
                    });
                    
                }
            ]
        );
    }
    variableRefactorCallback(varId, parentModuleId) {
        window.apm.popup(window.l.popup.refactor_variable,
            '<div class="new_element_container"></div>',
            '<button class="w2ui-btn secondary" onclick="w2popup.close();">' + window.l.popup.close + '</button> ' +
            '<button class="w2ui-btn primary add-button">' + window.l.popup.refactor + '</button> ',
            [
                ".new_element_container",

                () => {
                    ReactDOM.render(
                        <VariableRefactorDialog varId={varId}
                            parentModuleId={parentModuleId} />, $(".new_element_container").get(0));
                    $(".w2ui-popup").find(".add-button").on("click", function () {
                        document.dispatchEvent(new CustomEvent("ev-dialog-add"));
                    });
                
                }
            ]
            
        );
    }

    /**
     * Render the sub context menu for clicking on "+" on both treeview
     * @returns {XML}
     */
    renderTreeTitleMenu() {
        const prefix = this.props.context;
        if (prefix === "library") {
            return (
                <ul key={prefix}>
                    {!Utility.getIsCommonModule(window.apm.serialized) &&
                        <TextContextItem prefixIcon={"hash"} label={window.l.library.new_app_variable} context={this}
                            key={prefix + "newVariable"}
                            onClick={() => this.treeTitleMenuCallback("variable")} />}
                    {
                        <TextContextItem prefixIcon={"disc"} label={window.l.library.new_object} context={this}
                            key={prefix + "newObject"}
                            onClick={() => this.treeTitleMenuCallback("object")} />}
                    {
                        <TextContextItem prefixIcon={"package"} label={window.l.library.new_module} context={this}
                            key={prefix + "newModule"}
                            onClick={() => this.treeTitleMenuCallback("module")} />}
                    {
                        <TextContextItem prefixIcon={"radio"} label={window.l.library.new_intent} context={this}
                            key={prefix + "newIntent"}
                            onClick={() => this.treeTitleMenuCallback("intent")} />}
                </ul>
            );
        }
        if (prefix === "member") {
            return (
                <ul key={prefix}>
                    {
                        <TextContextItem prefixIcon={"hash"} label={window.l.library.new_local_variable} context={this}
                            key={prefix + "newVariable"}
                            onClick={() => window.apm.getCurrentDiagramWidget().openNewLocalVariableDialog({ isLocalVar: false, useModule: window.apm.getCurrentDiagramWidget().props.node.id })} />}
                </ul>
            );
        }
        if (prefix === "dialogs") {
            const treeD = $("#td_container");
            const isSelected = treeD.jstree().get_selected(true).length > 0;
            return (
                <ul key={prefix}>
                    <TextContextItem label="New sample dialog" context={this}
                        key={prefix + "new_sample_dialog"}
                        onClick={() => {
                            document.dispatchEvent(new CustomEvent("ev-dialog-node-add", { detail: { type: "folder" } }));
                        }} />
                    {isSelected && <TextContextItem label="New prompt" context={this}
                        key={prefix + "new_prompt"}
                        onClick={() => {
                            document.dispatchEvent(new CustomEvent("ev-dialog-node-add", { detail: { type: "prompt" } }));
                        }} />}
                    {isSelected && <TextContextItem label="New user turn" context={this}
                        key={prefix + "new_input"}
                        onClick={() => {
                            document.dispatchEvent(new CustomEvent("ev-dialog-node-add", { detail: { type: "input" } }));
                        }} />}
                    {isSelected && <TextContextItem label="New system annotation" context={this}
                        key={prefix + "new_system"}
                        onClick={() => {
                            document.dispatchEvent(new CustomEvent("ev-dialog-node-add", { detail: { type: "system" } }));
                        }} />}

                </ul>
            );
        }
    }

    renderCanvasTabMenu(e) {
        return (
            <ul key={this.props.type}>
                {
                    <TextContextItem label={window.l.context_menu.close_module} key={this.props.type + "closeModule"}
                        context={this} domContext={this.props.domContext}
                        onClick={() => {
                            this.props.context.closeCurrentModule(this.props.tabId);
                            this.wrapperRef.parentElement.parentElement.focus()
                        }} />}
                {
                    <TextContextItem label={window.l.context_menu.close_all_modules}
                        key={this.props.type + "closeAllModules"} context={this}
                        domContext={this.props.domContext}
                        onClick={() => {
                            this.props.context.closeAllModules();
                            this.wrapperRef.parentElement.parentElement.focus()
                        }} />}
                {
                    <TextContextItem label={window.l.context_menu.close_other_modules}
                        key={this.props.type + "closeOtherModules"} context={this}
                        domContext={this.props.domContext}
                        onClick={() => {
                            this.props.context.closeOtherModules(this.props.tabId);
                            this.wrapperRef.parentElement.parentElement.focus()
                        }} />}
                {
                    <TextContextItem label={window.l.context_menu.close_all_modules_to_right}
                        key={this.props.type + "closeAllModulesToRight"} context={this}
                        domContext={this.props.domContext}
                        onClick={() => {
                            this.props.context.closeModulesToRight(this.props.tabId);
                            this.wrapperRef.parentElement.parentElement.focus()
                        }} />}
                        {
                    <TextContextItem label={window.l.context_menu.close_all_modules_to_left}
                        key={this.props.type + "closeAllModulesToLeft"} context={this}
                        domContext={this.props.domContext}
                        onClick={() => {
                            this.props.context.closeModulesToLeft(this.props.tabId);
                            this.wrapperRef.parentElement.parentElement.focus()
                        }} />}
                {
                    <TextContextItem label={window.l.popup.used_in} context={this} key={this.props.type + "used"}
                        onClick={() => {
                            const node = window.apm.serialized.components.modules.find(mod => mod.id === this.props.tabId);
                            const icon = 'fe icon-' + node.props.iconClass;
                            window.apm.popup("<i class='" + icon + "' style='padding-right: 4px'></i>" + node.name + " used in:",
                                '<div class="new_element_container"></div>',
                                '<button class="w2ui-btn primary">' + window.l.popup.close + '</button> ',
                                [
                                    ".new_element_container",

                                    () => {
                                        ReactDOM.render(
                                            <UsedInDialog
                                                isComponentNode={true}
                                                node={node}
                                                serialized={window.apm.serialized}
                                                nodeId={this.props.tabId} />, $(".new_element_container").get(0));

                                        $(".w2ui-popup").find(".w2ui-btn.primary").on("click", function () {
                                            ReactDOM.unmountComponentAtNode($(".new_element_container").get(0));
                                            w2popup.close();
                                        });
                                    
                                    }
                                ]
                                
                            );
                        }} />}
                        {
                    <TextContextItem label={window.l.context_menu.reload_module} key={this.props.type + "reloadModule"}
                        context={this} domContext={this.props.domContext}
                        onClick={() => {
                            this.props.context.reloadModule();
                            
                        }} />}
                        {
                    <TextContextItem label={window.l.context_menu.copy_module_name} key={this.props.type + "copyModuleName"}
                        context={this} domContext={this.props.domContext}
                        onClick={() => {
                            const node = window.apm.serialized.components.modules.find(mod => mod.id === this.props.tabId);
                            this.props.context.copyModuleName(node.name);
                            
                        }} />}
            </ul>
        );
    }

    /**
     * Render context menu for clicking on an item inside member treeview
     * @returns {XML}
     */
    renderLocalTreeMenu() {
        const prefix = "tree2";
        const node = this.props.context;

        switch (node.type) {
            case "variables":
                return (
                    <ul key={node.id}>
                        {!window.apm.getCurrentDiagramWidget().props.node.props.isCommonModule &&
                            <TextContextItem label={window.l.library.new_local_variable} context={this}
                                key={prefix + node.type + "new"}
                                onClick={() => window.apm.getCurrentDiagramWidget().openNewLocalVariableDialog({ isLocalVar: false, useModule: window.apm.getCurrentDiagramWidget().props.node.id })} />}

                    </ul>

                );
                break;
            case "modules":
            case "objects":
            case "intents":
                break;
            default:
                return (
                    <ul key={node.id}>
                        {
                            <TextContextItem label={window.l.context_menu.rename} context={this}
                                key={prefix + node.type + "rename"}
                                onClick={() => this.variableRefactorCallback(node.id, window.apm.getCurrentDiagramWidget().props.node.id)} />}
                        {
                            <TextContextItem label={window.l.context_menu.clone} context={this}
                                key={prefix + node.type + "duplicate"}
                                onClick={() => {
                                    const newNode = window.apm.getVariable(node.id, window.apm.getCurrentDiagramWidget().props.node.id);
                                    if (newNode) {
                                        const nodeModel = new VariableDataModel(newNode.props);
                                        const nodeVarName = window.apm.getEligibleVariableName(nodeModel.getConfig("varName"), window.apm.getCurrentDiagramWidget().props.node.id);
                                        nodeModel.setConfig("varName", nodeVarName);
                                        window.apm.setVariable(
                                            nodeModel.getConfig("varName"),
                                            newNode.props.config.type,
                                            null,
                                            window.apm.getCurrentDiagramWidget().props.node.id,
                                            nodeModel.props.config
                                        );
                                    }
                                }} />}
                        
                            <TextContextItem label={window.l.context_menu.remove} context={this}
                                key={prefix + node.type + "remove"}
                                onClick={() => {
                                    const node = window.apm.getVariable(this.props.context.id, window.apm.getCurrentDiagramWidget().props.node.id);
                                    const module = window.apm.serialized.components.modules.find(m => m.id === window.apm.getCurrentDiagramWidget().props.node.id)
                                    window.apm.popup(node.name,
                                        '<div class="new_element_container">Are you sure you want to delete?</div>',
                                        ' <button class="w2ui-btn primary">' + window.l.popup.yes + '</button> ' +
                                        '<button class="w2ui-btn secondary">' + window.l.popup.no + '</button> ', 
                                        [
                                            ".new_element_container",
                                            () => {
                                                ReactDOM.render(
                                                    <UsedInDialog
                                                    serialized={window.apm.serialized}
                                                    module={module}
                                                    node={node} isLocalVariable={true} />, $(".new_element_container").get(0));
    
                                                $(".w2ui-popup").find(".w2ui-btn.primary").on("click", function () {
                                                    
                                                        window.apm.postEventToCurrentView({
                                                            target: "request-remove-local-variable",
                                                            varIdOrName: node.id,
                                                            module: module
                                                        });
                                                    
                                                    ReactDOM.unmountComponentAtNode($(".new_element_container").get(0));
                                                    w2popup.close();
                                                });
    
                                                $(".w2ui-popup").find(".w2ui-btn.secondary").on("click", function () {
                                                    ReactDOM.unmountComponentAtNode($(".new_element_container").get(0));
                                                    w2popup.close();
                                                });
                                            
                                            }

                                        ],
                                        700, node);

                                }} />

                           <TextContextItem label={window.l.popup.used_in} context={this} key={prefix + "used"}
                            onClick={() => {
                                const node = window.apm.getVariable(this.props.context.id, window.apm.getCurrentDiagramWidget().props.node.id);
                                const module = window.apm.serialized.components.modules.find(m => m.id === window.apm.getCurrentDiagramWidget().props.node.id)
                                window.apm.popup(node.name,
                                    '<div class="new_element_container"></div>',
                                    '<button class="w2ui-btn primary">' + window.l.popup.close + '</button> ',
                                    [
                                        ".new_element_container",

                                        () => {
                                            ReactDOM.render(
                                                <UsedInDialog
                                                    serialized={window.apm.serialized}
                                                    module={module}
                                                    node={node} isLocalVariable={true} />, $(".new_element_container").get(0)
                                            );
                                            $(".w2ui-popup").find(".w2ui-btn.primary").on("click", function () {
                                                ReactDOM.unmountComponentAtNode($(".new_element_container").get(0));
                                                w2popup.close();
                                            });
                                        
                                        }
                                    ]
                                    
                                );
                            }} />

                    </ul>
                );
                break;
        }
    }

    async openCommonModuleWizard(node) {
        const commonModule = await avsService.getCommonModuleDesignByName(
            node.repoName,
            node.repoVersion
        );
        if (commonModule && commonModule.wizardConfig) {
            window.apm.openCommonModuleWizard(commonModule, false, node.id);
        }
    }

    /**
     * Render context menu for clicking on an item inside application treeview
     * @returns {XML}
     */
    renderTreeMenu() {
        const prefix = "tree1";
        const prefix2 = "tree2";
        const treeNodes = this.props.context.filter(node => !node.type.endsWith("s"));
        const wizardConfig= Utility.getCookieBool(FeatureFlag.wizardConfig);
        if (treeNodes.length > 1) {
            return (
                <ul key={prefix + Utility.uuid4()}>
                    <TextContextItem label={window.l.context_menu.edit_diagram} context={this} key={prefix + Utility.uuid4()}
                        onClick={() => {
                            treeNodes.forEach(treeNode => {
                                if (treeNode.type === "module") {
                                    const node = window.apm.getNode(treeNode.id);
                                    if (!window.apm.hasPermission(node.id, "read")) {
                                        window.apm.notification.post("error", window.l.notification.no_permission);
                                        return;
                                    }
                                    CanvasTabManager.addTab(node);
                                }
                            });
                        }} />
                    <TextContextItem label={window.l.context_menu.remove} context={this} key={prefix + Utility.uuid4()}
                        onClick={() => {
                            function deletePopup(treeNodesToDelete) {
                                if (!treeNodesToDelete.length) {
                                    return;
                                }
                                const treeNode = treeNodesToDelete.pop();
                                const node = window.apm.getNode(treeNode.id);
                                if (!node.props.isCommonModule && node.props.config.lockName !== true && node._class !== "BeginNodeModel") {
                                    window.apm.popup(window.l.context_menu.remove + node.name,
                                        '<div class="new_element_container"></div>',
                                        '<button class="w2ui-btn secondary">' + window.l.popup.close + '</button> ' +
                                        '<button class="w2ui-btn primary add-button">' + window.l.popup.yes + '</button> ',
                                        [
                                            ".new_element_container",
                                            () => {
                                                ReactDOM.render(
                                                    <UsedInDialog
                                                        isComponentNode={true}
                                                        node={node}
                                                        serialized={serialized}
                                                        nodeId={node.id} />, $(".new_element_container").get(0));
                                                $(".w2ui-popup").find(".add-button").on("click", () => {
                                                    window.apm.removeComponents(() => deletePopup(treeNodesToDelete), node, treeNode);
                                                });
                                                $(".w2ui-popup").find(".w2ui-btn.secondary").on("click", function () {
                                                    ReactDOM.unmountComponentAtNode($(".new_element_container").get(0));
                                                    w2popup.close();
                                                });
                                            
                                            }
                                        ]
                                        ,
                                        700, node, treeNode);
                                }
                            }
                            deletePopup(treeNodes);
                        }} />
                </ul>
            );
        }
        const treeNode = this.props.context[0];

        switch (treeNode.type) {
            case "variables":
                if (Utility.getIsCommonModule(window.apm.serialized)) {
                    break;
                }
            case "modules":
            case "objects":
            case "intents":
                var name = treeNode.type.slice(0, -1);
                return (
                    <ul key={treeNode.id}>
                        {
                            <TextContextItem label={window.l.context_menu.new_space + window.l.context_menu[name]}
                                context={this} key={prefix + treeNode.type + "new"}
                                onClick={() => {
                                    this.treeTitleMenuCallback(treeNode.type.substring(0, treeNode.type.length - 1));
                                }} />}
                        {treeNode.type === "modules" &&
                            <TextContextItem label={"Edit Module Folders"}
                                context={this} key={prefix2 + treeNode.type + "new"}
                                onClick={() => {
                                    this.treeTitleFolderMenuCallback(treeNode.type.substring(0, treeNode.type.length - 1));
                                }} />}
                    </ul>
                );
                break;
            default:
                const node = window.apm.getNode(treeNode.id);
                let ismodglob = false;
                let theErrorMessage = "Error";
                const removeone = () => {
                    window.apm.notification.post("error", theErrorMessage);
                };
                const removetwo = () => {
                    window.apm.popup(window.l.context_menu.remove + " " + node.name,
                        '<div class="new_element_container"></div>',
                        ' <button class="w2ui-btn primary" onclick="window.apm.removeComponents()">' + window.l.popup.yes + '</button> ' +
                        '<button class="w2ui-btn secondary">' + window.l.popup.no + '</button> ',
                        [
                            ".new_element_container",
                            () => {
                                ReactDOM.render(
                                    <UsedInDialog
                                        isComponentNode={true}
                                        node={node}
                                        serialized={window.apm.serialized}
                                        nodeId={node.id} />, $(".new_element_container").get(0));

                                $(".w2ui-popup").find(".w2ui-btn.secondary").on("click", function () {
                                    ReactDOM.unmountComponentAtNode($(".new_element_container").get(0));
                                    w2popup.close();
                                });
                            
                            }
                        ]
                        ,
                        700, node, treeNode);

                };
                if (node.type === "module") {
                    // error module used in global intents
                    if (window.apm.serialized.globalIntents && window.apm.serialized.globalIntents.filter(gi => gi.module === node.id) > 0) {
                        ismodglob = true;
                        theErrorMessage = "Remove Module From Global Intent Map First";
                    }

                }
                var lockName = false;
                try {
                    lockName = node.props.config.lockName;
                } catch (e) {
                }
                return (
                    <ul key={node.id}>
                        {node.type === "module" &&
                            <TextContextItem label={window.l.context_menu.edit_diagram} context={this}
                                key={prefix + node.type + "edit"}
                                onClick={() => {
                                    if (node.type === "module") {
                                        if (!window.apm.hasPermission(node.id, "read")) {
                                            window.apm.notification.post("error", window.l.notification.no_permission);
                                            return;
                                        }

                                        CanvasTabManager.addTab(node)

                                    }
                                }} />}
                        {node.type === "module" &&node.props.isCommonModule&& wizardConfig&&
                            <TextContextItem label={"Open Wizard Config"} context={this}
                                key={prefix + node.type + "wizard"}
                                enableCheck={ node.props.hasWizardConfig}
                                onClick={() => {
                                    this.openCommonModuleWizard(node);
                                }} />}


                        {!lockName && !node.props.isCommonModule &&
                            <TextContextItem label={window.l.context_menu.duplicate} context={this}
                                key={prefix + node.type + "duplicate"}
                                onClick={() => {
                                    const treeDom = $('#tl_container');
                                    var newNode = JSON.parse(JSON.stringify(node));
                                    newNode.id = Utility.uuid4();
                                    newNode.props.usedIn = [];
                                    if (newNode.type === "variable") {
                                        const nodeModel = new VariableDataModel(newNode.props);
                                        const nodeVarName = window.apm.getEligibleVariableName(nodeModel.getConfig("varName"));
                                        nodeModel.setConfig("varName", nodeVarName);
                                        nodeModel.name = nodeModel.getConfig("name");
                                        newNode = nodeModel.serialize();
                                    } else {
                                        newNode.name = window.apm.getEligibleTreeName(treeDom, newNode.name, newNode.type, newNode.props.nodeTypeName);
                                    }
                                    if (newNode.type === "module") {
                                        newNode.props.ref = newNode.id;
                                        for (var n = 0; n < newNode.versions[1].flow.nodes.length; n++) {
                                            var existNode = newNode.versions[1].flow.nodes[n].id;
                                            newNode.versions[1].flow.nodes[n].id = Utility.uuid4();
                                            if (JSON.stringify(newNode.versions[1].flow.links).includes(existNode)) {
                                                (newNode.versions[1].flow.links = JSON.parse(JSON.stringify((newNode.versions[1].flow.links)).replace(new RegExp(existNode, 'gi'), newNode.versions[1].flow.nodes[n].id)));
                                            }
                                        }
                                        for (var l = 0; l < newNode.versions[1].flow.links.length; l++) {

                                            newNode.versions[1].flow.links[l].id = Utility.uuid4();

                                        }
                                    }
                                    window.apm.addNode(newNode);
                                    treeDom.jstree().create_node(treeNode.parent, Utility.getTreeNode(newNode), "last", (new_node) => {
                                        treeDom.jstree().deselect_all();
                                        treeDom.jstree().select_node(newNode.id);
                                        window.apm.postEventToCurrentView({ target: "request-clear-selection" });
                                        window.apm.postEventToCurrentView({
                                            target: "request-component-panel",
                                            event: newNode
                                        });
                                        if (newNode.type !== "variable") {
                                            treeDom.jstree().edit(new_node, null, () => {
                                                new_node.text = new_node.text.toUpperCase().replace(/ /g, "_");
                                                if (window.apm.isTreeNameDuplicated(treeDom, new_node.text, new_node.type, parent, new_node.id)) {
                                                    window.apm.notification.post('error', window.l.notification.name_already_taken);
                                                    window.apm.renameNode(new_node.id, new_node.text, treeDom);
                                                }
                                                window.apm.renameNode(new_node.id, new_node.text, treeDom);
                                                treeDom.jstree().deselect_all();
                                                treeDom.jstree().select_node(new_node);
                                                window.apm.postEventToCurrentView({ target: "request-clear-selection" });
                                                window.apm.postEventToCurrentView({
                                                    target: "request-component-panel",
                                                    event: newNode
                                                });
                                            });
                                        }
                                    });
                                    document.dispatchEvent(new CustomEvent("ev-dialog-variable-changed"));
                                }} />}
                        {!node.props.isCommonModule && node.props.config.lockName !== true && node._class !== "BeginNodeModel" &&
                            <TextContextItem label={window.l.context_menu.remove} context={this}
                                key={prefix + node.type + "remove"}
                                onClick={ismodglob ? removeone : removetwo} />}

                        {node.props.isCommonModule && node.props.config.lockName !== true && node._class !== "BeginNodeModel" &&
                            <TextContextItem label={window.l.context_menu.remove} context={this}
                                key={prefix + node.type + "remove"}
                                onClick={() => {

                                    window.apm.popup(node.name,
                                        '<div class="new_element_container">Are you sure you want to delete?</div>',
                                        ' <button class="w2ui-btn primary">' + window.l.popup.yes + '</button> ' +
                                        '<button class="w2ui-btn secondary">' + window.l.popup.no + '</button> ', 
                                        [
                                            ".new_element_container",

                                            () => {
                                                ReactDOM.render(
                                                    <UsedInDialog
                                                        isComponentNode={true}
                                                        serialized={window.apm.serialized}
                                                        node={node}
                                                        nodeId={node.id} />, $(".new_element_container").get(0));

                                                $(".w2ui-popup").find(".w2ui-btn.primary").on("click", function () {
                                                    window.apm.removeCommonModule(node);
                                                    w2popup.close();
                                                });

                                                $(".w2ui-popup").find(".w2ui-btn.secondary").on("click", function () {
                                                    ReactDOM.unmountComponentAtNode($(".new_element_container").get(0));
                                                    w2popup.close();
                                                });
                                            
                                            }

                                        ],
                                        700, node, treeNode);

                                }} />}
                        {
                            <TextContextItem label={window.l.popup.used_in} context={this}
                                key={prefix + node.type + "used"}
                                onClick={() => {
                                    const icon = 'fe icon-' + node.props.iconClass;
                                    window.apm.popup("<i class='" + icon + "' style='padding-right: 4px'></i>" + node.name + " used in:",
                                        '<div class="new_element_container" style="margin: 2em"></div>',
                                        '<button class="w2ui-btn primary">' + window.l.popup.close + '</button> ',
                                        [
                                            ".new_element_container",

                                            () => {
                                                ReactDOM.render(
                                                    <UsedInDialog
                                                        isComponentNode={true}
                                                        serialized={window.apm.serialized}
                                                        node={node}
                                                        nodeId={node.id} />, $(".new_element_container").get(0));

                                                $(".w2ui-popup").find(".w2ui-btn.primary").on("click", function () {
                                                    ReactDOM.unmountComponentAtNode($(".new_element_container").get(0));
                                                    w2popup.close();
                                                });
                                            
                                            }

                                        ],
                                        700
                                    );
                                }} />}

                        {node.props.config.lockName !== true && !node.props.isCommonModule &&
                            <TextContextItem label={window.l.context_menu.export_element} context={this}
                                key={prefix + node.type + "export"}
                                onClick={() => {
                                    const filename = (node.type + "_" + node.name).replace(/([^a-z0-9]+)/gi, '_');
                                    const blob = new Blob([JSON.stringify(window.apm.exportNode(node.id))], { type: "text/plain;charset=utf-8" });
                                    FileSaver.saveAs(blob, filename + "_D2.json");
                                }} />}
                    </ul>
                );
                break;
        }
    }

    renderFolderMenu() {

        return (
            <ul key={this.props.folderid + "_key"}>
                {
                    <TextContextItem label={"Rename Folder"}
                        onClick={() => this.props.folderrename()}
                        context={this}
                    />}
                {
                    <TextContextItem label={"Delete Folder"}
                        onClick={() => this.props.folderdelete()}
                        context={this}
                    />}
            </ul>
        );
    }

    renderDialogTreeMenu() {
        const prefix = "dialogTree";
        const treeNodes = this.props.context;
        if (treeNodes.length > 1) {
            return (
                <ul key={prefix + Utility.uuid4()}>
                    <TextContextItem label={`Remove all from dialog`} context={this}
                        key={Utility.uuid4()}
                        onClick={() => {
                            treeNodes.forEach(treeNode => {
                                document.dispatchEvent(new CustomEvent("ev-dialog-node-remove", { detail: treeNode.id }));
                            });
                        }} />
                </ul>
            );
        }
        const treeNode = treeNodes[0];

        switch (treeNode.type) {
            case "folder":
                return (
                    <ul key={treeNode.id}>
                        <TextContextItem label="Duplicate sample dialog" context={this}
                            key={prefix + treeNode.type + "duplicate"}
                            onClick={() => {
                                document.dispatchEvent(new CustomEvent("ev-dialog-node-duplicate", { detail: treeNode.id }));
                            }} />
                        <TextContextItem label="Remove sample dialog" context={this}
                            key={prefix + treeNode.type + "remove"}
                            onClick={() => {
                                w2confirm({
                                    msg: `By removing ${treeNode.data.name}, all conversations under this sample dialog will be deleted\. Do you wish to continue?`,
                                    title: 'Removing Sample Dialog',
                                    width: 450,
                                    height: 220,
                                    btn_yes: {
                                        text: 'No',
                                        style: '',
                                        class: 'secondary',
                                        callBack: null
                                    },
                                    btn_no: {
                                        text: 'Yes',
                                        style: '',
                                        class: 'primary',
                                        callBack: () => document.dispatchEvent(new CustomEvent("ev-dialog-node-remove", { detail: treeNode.id }))
                                    },
                                    callBack: null     // common callBack
                                });
                            }} />
                        <TextContextItem label="New prompt" context={this}
                            key={prefix + treeNode.type + "new_prompt"}
                            onClick={() => {
                                document.dispatchEvent(new CustomEvent("ev-dialog-node-add", { detail: { type: "prompt" } }));
                            }} />
                        <TextContextItem label="New user turn" context={this}
                            key={prefix + treeNode.type + "new_input"}
                            onClick={() => {
                                document.dispatchEvent(new CustomEvent("ev-dialog-node-add", { detail: { type: "input" } }));
                            }} />
                        <TextContextItem label="New system annotation" context={this}
                            key={prefix + treeNode.type + "new_system"}
                            onClick={() => {
                                document.dispatchEvent(new CustomEvent("ev-dialog-node-add", { detail: { type: "system" } }));
                            }} />
                    </ul>
                );
            default:
                return (
                    <ul key={treeNode.id}>
                        <TextContextItem label={`Remove from dialog`} context={this}
                            key={prefix + treeNode.type + "remove"}
                            onClick={() => {
                                document.dispatchEvent(new CustomEvent("ev-dialog-node-remove", { detail: treeNode.id }));
                            }} />
                        {treeNode.type === "prompt" &&
                            <TextContextItem label={`Delete from app`} context={this}
                                key={prefix + treeNode.type + "delete"}
                                onClick={() => {
                                    const node = window.apm.getNode(treeNode.data.parentComponentID);
                                    window.apm.popup(`Delete ${treeNode.data.name} from application?`,
                                        '<div class="delete_prompt_container"></div>',
                                        ' <button class="w2ui-btn secondary">' + window.l.popup.no + '</button> ' +
                                        '<button class="w2ui-btn primary delete-button">' + window.l.popup.yes + '</button> ',
                                        [
                                            ".delete_prompt_container",

                                            () => {
                                                ReactDOM.render(
                                                    <UsedInDialog
                                                        isComponentNode={true}
                                                        node={node}
                                                        serialized={window.apm.serialized}
                                                        nodeId={node.id} />, $(".delete_prompt_container").get(0));
                                                $(".w2ui-popup").find(".delete-button").on("click", function () {
                                                    window.apm.removeComponents();
                                                });

                                                $(".w2ui-popup").find(".w2ui-btn.secondary").on("click", function () {
                                                    ReactDOM.unmountComponentAtNode($(".new_element_container").get(0));
                                                    w2popup.close();
                                                });
                                            
                                            }

                                        ],
                                        700, node, $('#tl_container').jstree().get_node(node.id));
                                }} />}
                        <TextContextItem label="New prompt" context={this}
                            key={prefix + treeNode.type + "new_prompt"}
                            onClick={() => {
                                document.dispatchEvent(new CustomEvent("ev-dialog-node-add", { detail: { type: "prompt" } }));
                            }} />
                        <TextContextItem label="New system annotation" context={this}
                            key={prefix + treeNode.type + "new_system"}
                            onClick={() => {
                                document.dispatchEvent(new CustomEvent("ev-dialog-node-add", { detail: { type: "system" } }));
                            }} />
                        <TextContextItem label="New user turn" context={this}
                            key={prefix + treeNode.type + "new_input"}
                            onClick={() => {
                                document.dispatchEvent(new CustomEvent("ev-dialog-node-add", { detail: { type: "input" } }));
                            }} />

                    </ul>
                );
        }
    }

    renderUnitTestMenu() {
        const prefix = "unitTest";
        return (
            <ul key={this.props.context}>
                {this.props.context.length === 1 && <TextContextItem label={`Download`} context={this}
                    key={prefix + "download"}
                    onClick={() => {
                        document.dispatchEvent(new CustomEvent("ev-unit-test-download", { detail: { id: this.props.context[0] } }));
                    }} />}
                {this.props.context.length === 1 && <TextContextItem label={`Rename`} context={this}
                    key={prefix + "rename"}
                    onClick={() => {
                        document.dispatchEvent(new CustomEvent("ev-unit-test-rename", { detail: { id: this.props.context[0] } }));
                    }} />}
                <TextContextItem label={`Delete`} context={this}
                    key={prefix + "delete"}
                    onClick={() => {
                        document.dispatchEvent(new CustomEvent("ev-unit-test-delete", { detail: this.props.context }));
                    }} />
            </ul>
        );
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        window.apm.printDebug("Context menu", {
            context: this.props.context,
            type: this.props.type
        }, Constant.k.DEBUG_UI);
        return (
            <div ref={this.setWrapperRef.bind(this)}>
                {(() => {
                    if (this.props.type === "multipleSelection") {
                        return this.renderSelectionMenu();
                    } else if (this.props.type === "singleSelection") {
                        if (this.props.context === null) {
                            // canvas
                            return this.renderCanvasMenu();
                        } else {
                            if (this.props.context.model instanceof DIAG.LinkModel) {
                                return this.renderLinkMenu();
                            } else if (this.props.context.model instanceof DIAG.NodeModel) {
                                return this.renderNodeMenu();
                            }
                        }
                    } else if (this.props.type === "localTreeNode" && !window.apm.getCurrentDiagramWidget().props.node.props.isCommonModule) {
                        return this.renderLocalTreeMenu();
                    } else if (this.props.type === "treeNode") {
                        return this.renderTreeMenu();
                    } else if (this.props.type === "treeTitle") {
                        return this.renderTreeTitleMenu();
                    } else if (this.props.type === 'canvastab') {
                        return this.renderCanvasTabMenu();
                    } else if (this.props.type === "folderNode") {
                        return this.renderFolderMenu();
                    } else if (this.props.type === "dialogTreeNode") {
                        return this.renderDialogTreeMenu();
                    } else if (this.props.type === "unitTest") {
                        return this.renderUnitTestMenu()
                    }
                    return <span />;
                })()}
            </div>
        );
    }
}

/**
 * Context menu line item views
 */

/**
 * @class TextContextItem
 */
class TextContextItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            onClick: this.props.hasOwnProperty("onClick") ? this.props.onClick : () => {
            },
            enableCheck: this.props.hasOwnProperty("enableCheck") ? this.props.enableCheck : () => {
                return true;
            },
            showJsx: false
        };
        this.timer = null;
    }

    getDomSelf() {
        return $(ReactDOM.findDOMNode(this));
    }

    removeSubmenu() {
        this.setState({ showJsx: false });
    }

    render() {
        return (
            <li
                tabIndex={0}
                onKeyDown={event => {
                    switch (event.keyCode) {
                        case 13:    // enter
                            event.preventDefault();
                            $(event.currentTarget).click();
                            break;
                        case 38:    // up arrow
                            let prev = $(event.currentTarget).prev().filter('[tabindex=0]');
                            if (!prev.length) {
                                prev = $(event.currentTarget).prevAll('li:first').find('[tabindex=0]:first');
                            }
                            prev.focus();
                            break;
                        case 40:    // down arrow
                            let next = $(event.currentTarget).next().filter('[tabindex=0]');
                            if (!next.length) {
                                next = $(event.currentTarget).nextAll('li:first').find('[tabindex=0]:first');
                            }
                            next.focus();
                            break;
                    }
                }}
                onMouseEnter={event => {
                    if (this.props.context.props.type === "singleSelection") {
                        switch (this.props.label) {
                            case "Replace With...":
                                $(".link_wrapper")[0].innerText = "Replaces the selected object/module with a new object/module while preserving any attached links/transitions.";
                                break;
                            case "Copy":
                                $(".link_wrapper")[0].innerText = "Copy the object to the clipboard. You can then right-click on a canvas to paste either a reference to the copied object or a clone of the copied object.";
                                break;
                            case "Clone and Replace":
                                $(".link_wrapper")[0].innerText = "Create a new object identical to the selected one and replace the selected object with the new one. Transitions bound to the selected object will become bound to the new one.";
                                break;
                            case "Clone":
                                $(".link_wrapper")[0].innerText = "Create a new object identical to the selected one and place it on the canvas. If a module is cloned the objects in the new module will be object references and not clones.";
                                break;
                            case "Cut":
                                $(".link_wrapper")[0].innerText = "Copy the object to the clipboard and remove it from the canvas.";
                                break;
                            case "Used in":
                                $(".link_wrapper")[0].innerText = "Check to see where else in the application the object is used in.";
                                break;
                            case "Remove":
                                $(".link_wrapper")[0].innerText = "Remove the object from the canvas.";
                                break;
                            case "Create New Object":
                                $(".link_wrapper")[0].innerText = "Create a new application object and place it on the canvas.";
                                break;
                            case "Paste here":
                                $(".link_wrapper")[0].innerText = "Place a reference to the copied object to the canvas.";
                                break;
                            case "Paste Clone":
                                $(".link_wrapper")[0].innerText = "Create a new object identical to the copied one and place it on the canvas.";
                                break;
                            case "Select All":
                                $(".link_wrapper")[0].innerText = "Select all objects and transitions on the canvas.";
                                break;
                            case "View Module Properties":
                                $(".link_wrapper")[0].innerText = "View the properties of the canvas module.";
                                break;
                            case "Insert Object":
                                $(".link_wrapper")[0].innerText = "Insert a new object into existing flow.";
                                break;

                        }
                        
                        window.apm.postEventToCurrentView({ target: "request-hide-property-panel"});
                        
                        if ($(".link_wrapper")[0].innerText !== "") $(".link_wrapper").css({ top: event.clientY, left: this.props.context.props.pos.left + 200 }).show();
                        this.setState({ showJsx: true });
                    }
                    

                }}
                onMouseLeave={event => {
                    $(".link_wrapper")[0].innerText = "";
                    $(".link_wrapper").hide();
                    if (this.timer !== null) {
                        clearTimeout(this.timer);
                        this.timer = null;
                    }
                    this.timer = setTimeout(((self) => {
                        self.setState({ showJsx: false });
                    })(this), 500);
                }}
                onClick={event => {
                    if (!this.props.hasOwnProperty("subcontext") && this.state.enableCheck) {
                        this.state.onClick(event);
                        this.removeSubmenu();
                        this.props.context.hideMenu();
                    } else {
                        this.setState({ showJsx: !this.state.showJsx });
                    }
                }}
                className={(() => {
                    if (!this.state.enableCheck) {
                        return "greyout";
                    }
                    return "normal";
                })()}
            >
                {(() => {
                    if (this.props.prefixIcon) {
                        return <i className={"fe icon-" + this.props.prefixIcon} style={{
                            marginRight: "4px",
                            fontSize: "16px"
                        }} />;
                    }
                })()}
                {this.props.label}
                {(() => {
                    if (this.props.hasOwnProperty("subcontext") && this.state.showJsx) {
                        return <Submenu context={this.props.context} content={this.props.subcontext} domContext={this}
                            asSubcontext={true} />;
                    }
                })()}
            </li>
        );
    }
}

/**
 * @class CarouselContextItem
 */
class CarouselContextItem extends React.Component {
    constructor(props) {
        super(props);
    }

    getMemberTree() {
        if (!this.memberTree) {
            this.memberTree = $('#tm_container');
        }
        return this.memberTree;
    }

    // This functionality is reserved for * MetLife only * 
    // 
    updateValue(key, event) {
        if(window.apm.serialized.client !== "MetLife"){
            return;
        }

        const value = event.currentTarget.dataset["value"];
        const model = this.props.context.props.context.model;
        
        if (model instanceof BaseNodeModel || model instanceof BaseLinkModel) {
            
            const currentViewId = window.apm.cache.get(Constant.k.NAMESPACE_DIAGRAM_WIDGET, "current-view");
            const currentDiagramWidget = window.apm.cache.get(Constant.k.NAMESPACE_DIAGRAM_WIDGET, currentViewId);
            
            
            model.setProperty(key, value);
            model.props.lastLocalChange = window.apm.timestamp;
            
            if (this.getMemberTree()) {
                this.getMemberTree().jstree().set_icon(model.id, "/lib/feather/" + model.getProperty("iconClass") + ".svg");
            }
            
            
            currentDiagramWidget.saveDatabase();
            // this.forceUpdate();
            
            window.apm.updateParentNode(model, model.props.parentyComponentID);

        }

        this.props.context.hideMenu();

        window.apm.postEventToCurrentView({ target: "request-refresh" });

        return;

    }

    render() {
        // if(window.apm.serialized.client === "MetLife"){

            return (
                <li className="carousel">
                    {<CarouselSample context={this} contextProps={this.props} />}
                    {<CarouselMore context={this} contextProps={this.props} />}
                </li>
            );
        // }
    }
}

/**
 * @class CarouselSample
 */
class CarouselSample extends React.Component {
    renderColor() {
        return ([
            <div key={"sample-container"} className="color-demo-container" style={{
                marginLeft: "-2px",
                marginRight: "7px"
            }}>
                <div className={"color-demo " + this.props.contextProps.context.props.context.model.props.colorClass} />
            </div>,
            <div key={"sample-break"} className="break">&nbsp;</div>,
            (() => {
                var sample = [];
                for (var i = 0; i < 6; i++) {
                    sample.push(
                        <div className="color-demo-container" key={demoColors[i] + i}
                            data-value={demoColors[i]}
                            tabIndex={0}
                            onKeyDown={event => {
                                switch (event.keyCode) {
                                    case 13:    // enter
                                        event.preventDefault();
                                        $(event.currentTarget).click();
                                        break;
                                    case 37:    // left arrow
                                        $(event.currentTarget).prev().filter('[tabindex=0]').focus();
                                        break;
                                    case 38:    // up arrow
                                        const prevLi = $(event.currentTarget).closest('.carousel').prevAll('li:first');
                                        let prev = prevLi.filter('[tabindex=0]');
                                        if (!prev.length) {
                                            prev = prevLi.find('[tabindex=0]:first');
                                        }
                                        prev.focus();
                                        break;
                                    case 39:    // right arrow
                                        $(event.currentTarget).next().filter('[tabindex=0]').focus();
                                        break;
                                    case 40:    // down arrow
                                        const nextLi = $(event.currentTarget).closest('.carousel').nextAll('li:first');
                                        let next = nextLi.filter('[tabindex=0]');
                                        if (!next.length) {
                                            next = nextLi.find('[tabindex=0]:first');
                                        }
                                        next.focus();
                                        break;
                                }
                            }}
                            onClick={(event) => this.props.context.updateValue("colorClass", event)}
                        >
                            <div className={"color-demo " + demoColors[i]} />
                        </div>
                    );
                }
                return sample;
            })()
        ]);
    }

    renderIcon() {
        return ([
            <div key={"sample-container"} className="icon-demo-container" style={{
                marginLeft: "-2px",
                marginRight: "7px"
            }}>
                <div className={"fe icon-" + this.props.contextProps.context.props.context.model.props.iconClass} />
            </div>,
            <div key={"sample-break"} className="break">&nbsp;</div>,
            (() => {
                var sample = [];
                for (var i = 0; i < 6; i++) {
                    sample.push(
                        <div className="icon-demo-container" key={demoIcons[i] + i}
                            data-value={demoIcons[i]}
                            tabIndex={0}
                            onKeyDown={event => {
                                switch (event.keyCode) {
                                    case 13:    // enter
                                        event.preventDefault();
                                        $(event.currentTarget).click();
                                        break;
                                    case 37:    // left arrow
                                        $(event.currentTarget).prev().filter('[tabindex=0]').focus();
                                        break;
                                    case 38:    // up arrow
                                        const prevLi = $(event.currentTarget).closest('.carousel').prevAll('li:first');
                                        let prev = prevLi.filter('[tabindex=0]');
                                        if (!prev.length) {
                                            prev = prevLi.find('[tabindex=0]:first');
                                        }
                                        prev.focus();
                                        break;
                                    case 39:    // right arrow
                                        $(event.currentTarget).next().filter('[tabindex=0]').focus();
                                        break;
                                    case 40:    // down arrow
                                        const nextLi = $(event.currentTarget).closest('.carousel').nextAll('li:first');
                                        let next = nextLi.filter('[tabindex=0]');
                                        if (!next.length) {
                                            next = nextLi.find('[tabindex=0]:first');
                                        }
                                        next.focus();
                                        break;
                                }
                            }}
                            onClick={(event) => this.props.context.updateValue("iconClass", event)}
                        >
                            <i className={"fe icon-" + demoIcons[i]} />
                        </div>
                    );
                }
                return sample;
            })()
        ]);
    }

    render() {
        if (this.props.contextProps.set === "color") {
            
                return this.renderColor();
            
        }
        return this.renderIcon();
    }
}

/**
 * @class CarouselMore
 */
class CarouselMore extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showJsx: false };
    }

    getDomSelf() {
        return $(ReactDOM.findDOMNode(this));
    }

    removeSubmenu() {
        // do nothing
    }

    // called on updates (re-renders)
    componentDidUpdate() {
        if (this.state.showJsx) {
            this.getDomSelf().find('[tabindex=0]:first').focus();
        }
    }

    // called on initial rendering
    componentDidMount() {
        if (this.state.showJsx) {
            this.getDomSelf().find('[tabindex=0]:first').focus();
        }
    }

    render() {
        return (
            <div
                className={"carousel-more " + this.props.contextProps.set}
                tabIndex={0}
                onKeyDown={event => {
                    switch (event.keyCode) {
                        case 13:    // enter
                            event.preventDefault();
                            this.setState({ showJsx: !this.state.showJsx });
                            break;
                        case 37:    // left arrow
                            event.preventDefault();
                            $(event.currentTarget).prev().filter('[tabindex=0]').focus();
                            break;
                    }
                }}
                onMouseEnter={event => {
                    this.setState({ showJsx: true });
                }}
                onMouseLeave={event => {
                    if (this.timer !== null) {
                        clearTimeout(this.timer);
                        this.timer = null;
                    }
                    this.timer = setTimeout(((self) => {
                        self.setState({ showJsx: false });
                    })(this), 500);
                }}
            ><i className="fe icon-chevron-right" />
                {(() => {
                    if (this.state.showJsx) {
                        if (this.props.contextProps.set === "color") {
                            return <Submenu context={this} content={ColorSubcontext} domContext={this}
                                asSubcontext={true} />;
                        }
                        return <Submenu context={this} content={IconSubcontext} domContext={this}
                            asSubcontext={true} />;
                    }
                })()}
            </div>
        );
    }
}

/**
 * @class ColorSubcontext
 */
class ColorSubcontext extends React.Component {
    render() {
        var samples = [];
        for (var i = 0; i < demoColors.length; i += 4) {
            var s = i, t = i + 4;
            var slice = demoColors.slice(s, t);
            if (t > demoColors.length) {
                slice = demoColors.slice(s);
            }
            var row = [];
            for (var j = 0; j < slice.length; j++) {
                row.push(
                    <div className="color-demo-container" key={slice[j] + j}
                        data-value={slice[j]}
                        tabIndex={0}
                        onKeyDown={event => {
                            event.stopPropagation();
                            const idx = $(event.currentTarget).index();
                            switch (event.keyCode) {
                                case 13:    // enter
                                    event.preventDefault();
                                    $(event.currentTarget).click();
                                    break;
                                case 27:    // escape
                                    event.preventDefault();
                                    $(event.currentTarget).closest('.carousel-more').focus();
                                    this.props.context.setState({ showJsx: false });
                                    break;
                                case 37:    // left arrow
                                    event.preventDefault();
                                    $(event.currentTarget).prev().filter('[tabindex=0]').focus();
                                    break;
                                case 38:    // up arrow
                                    event.preventDefault();
                                    const prev = $(event.currentTarget).parent().prev().children()[idx];
                                    if (prev) {
                                        prev.focus();
                                    }
                                    break;
                                case 39:    // right arrow
                                    event.preventDefault();
                                    $(event.currentTarget).next().filter('[tabindex=0]').focus();
                                    break;
                                case 40:    // down arrow
                                    event.preventDefault();
                                    const next = $(event.currentTarget).parent().next().children()[idx];
                                    if (next) {
                                        next.focus();
                                    }
                                    break;
                            }
                        }}
                        onClick={(event) => this.props.context.props.context.updateValue("colorClass", event)}>
                        <div className={"color-demo " + slice[j]} />
                    </div>
                );
            }
            if (row.length > 0) {
                samples.push(
                    <div className="more-row"
                        style={(() => {
                            if (i === 0) {
                                return { marginTop: "6px" };
                            }
                        })()}
                        key={"row" + i}>{row}</div>
                );
            }
        }

        return samples;
    }
}

/**
 * @class IconSubcontext
 */
class IconSubcontext extends React.Component {
    render() {
        var samples = [];
        for (var i = 0; i < demoIcons.length; i += 12) {
            var s = i, t = i + 12;
            var slice = demoIcons.slice(s, t);
            if (t > demoIcons.length) {
                slice = demoIcons.slice(s);
            }
            var row = [];
            for (var j = 0; j < slice.length; j++) {
                row.push(
                    <div className="icon-demo-container" key={slice[j] + j}
                        data-value={slice[j]}
                        tabIndex={0}
                        onKeyDown={event => {
                            event.stopPropagation();
                            const idx = $(event.currentTarget).index();
                            switch (event.keyCode) {
                                case 13:    // enter
                                    event.preventDefault();
                                    $(event.currentTarget).click();
                                    break;
                                case 27:    // escape
                                    event.preventDefault();
                                    $(event.currentTarget).closest('.carousel-more').focus();
                                    this.props.context.setState({ showJsx: false });
                                    break;
                                case 37:    // left arrow
                                    event.preventDefault();
                                    $(event.currentTarget).prev().filter('[tabindex=0]').focus();
                                    break;
                                case 38:    // up arrow
                                    event.preventDefault();
                                    const prev = $(event.currentTarget).parent().prev().children()[idx];
                                    if (prev) {
                                        prev.focus();
                                    }
                                    break;
                                case 39:    // right arrow
                                    event.preventDefault();
                                    $(event.currentTarget).next().filter('[tabindex=0]').focus();
                                    break;
                                case 40:    // down arrow
                                    event.preventDefault();
                                    const next = $(event.currentTarget).parent().next().children()[idx];
                                    if (next) {
                                        next.focus();
                                    }
                                    break;
                            }
                        }}
                        onClick={(event) => this.props.context.props.context.updateValue("iconClass", event)}
                    >
                        <i className={"fe icon-" + slice[j]} />
                    </div>
                );
            }
            if (row.length > 0) {
                samples.push(
                    <div className="more-row"
                        style={(() => {
                            if (i === 0) {
                                return { marginTop: "6px" };
                            }
                        })()}
                        key={"row" + i}>{row}</div>
                );
            }
        }

        return <div style={{ maxHeight: "200px", overflow: "auto" }}>{samples}</div>;
    }
}